import { MouseEventHandler } from 'react';
import styled from 'styled-components';
import colors from '../../../theme/colors';

interface IExitModalIcon {
    style?: any;
    onClick?: MouseEventHandler<HTMLSpanElement> | undefined;
    previewImageModal?: boolean;
}

const IconContainer = styled.span`
    display: flex;
    align-items: center;

    svg {
        stroke: ${(props) => props.theme.colors.white};
    }

    svg:hover {
        stroke: ${(props) => props.theme.colors.placeholder};
    }
`;

const ExitModalIcon: React.FC<IExitModalIcon> = ({style, onClick, previewImageModal}) => {
    return (
        <IconContainer style={style} onClick={onClick}>
            {previewImageModal ?
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 2L23.2903 23.2903" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 23.2903L23.2903 1.99996" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            :
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L13.7742 13.7742" stroke={colors.secondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1 13.7742L13.7742 0.999976" stroke={colors.secondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            }
        </IconContainer>
    )
}

export default ExitModalIcon;
